import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { getStatusConfig, type CarStatus } from '@/lib/status-utils';
import { useTranslation } from 'react-i18next';

interface StatusBadgeProps {
  status: string | CarStatus;
  className?: string;
}

/**
 * Unified Status Badge Component
 *
 * Displays car status with consistent styling across the application.
 * Automatically handles database status values (with underscores).
 *
 * Usage:
 *   <StatusBadge status={car.status} />
 */
export const StatusBadge = ({ status, className }: StatusBadgeProps) => {
  const { t } = useTranslation();
  const config = getStatusConfig(status);

  return (
    <Badge
      variant="outline"
      className={cn(
        'font-medium whitespace-nowrap',
        config.bgClass,
        config.textClass,
        config.borderClass,
        className
      )}
    >
      {t(config.labelKey)}
    </Badge>
  );
};
